import { useNavigate } from 'react-router-dom';
import { Globe } from '@phosphor-icons/react';
import { PageHeader } from '@/components/shared/PageHeader';
import { Card, CardContent } from '@/components/ui/card';

const PLANNED_SECTIONS: string[] = [
  'Home page — hero, intro and headline cases',
  'Barrister directory — public profiles, filterable by practice area',
  'Practice area landing pages',
  'Public judgements — indexed by court, judge and area',
  'Insights & news — articles authored by chambers staff',
  'Contact form — routes to senior clerks',
];

export default function PublicSitePage() {
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader
        onBack={() => navigate(-1)}
        title="Public Website"
        subtitle="Your chambers' public-facing site — barrister directory, judgements, instructions"
      />

      <Card className="mb-6">
        <CardContent className="px-6 py-12 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 text-brand-600 dark:text-brand-400">
            <Globe className="h-6 w-6" weight="bold" />
          </div>
          <div className="text-lg font-semibold text-foreground">Public website builder coming soon</div>
          <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground">
            The chambers public site will pull live data from the platform — barrister profiles,
            published judgements, practice areas — rather than being a separate CMS. SEO,
            enquiries inbox and theming land alongside it.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-5">
          <div className="mb-3 text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">
            Planned sections
          </div>
          <ul className="space-y-2 text-sm text-foreground">
            {PLANNED_SECTIONS.map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-muted-foreground/60" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
